// The front door (#/welcome, and the home screen for anyone who hasn't signed in or started yet): what Sketchy does,
// a Sign in button for people who already have an account, the working no-sign-in demo right under the headline, a "Make your own" button, then three short points, then a small "Get started" link into the app.
import { useEffect, useState } from "react";
import { Body, Page } from "../common";
import { EmbeddedQuick } from "../quick/QuickView";
import { TimelineLoader } from "../timeline/TimelineLoader";
import { demoEpisodeId } from "./demoEpisode";
import { account, signIn } from "../account";
import "../quick/quick.css";
import "./landing.css";

// PLACEHOLDER example channels: fill in real ones (name, followers, views as shown text).
const EXAMPLES = [
  { name: "Example channel one", followers: "1.2M followers", views: "48M views" },
  { name: "Example channel two", followers: "640K followers", views: "21M views" },
  { name: "Example channel three", followers: "310K followers", views: "9M views" },
];

export function Landing({ onOwn, onStart, onSignedIn }: { onOwn: () => void; onStart: () => void; onSignedIn: () => void }) {
  const [id, setId] = useState<string | null>(null);
  const [problem, setProblem] = useState<string | null>(null);
  useEffect(() => { demoEpisodeId().then(setId, e => setProblem((e as Error).message)); }, []);
  return (
    <Page className="sm lp">
      <Body className="lp-body">
        <div className="lp-top">
          <div className="wordmark lp-mark">sketchy</div>
          {/* Straight into an existing account, back to the home screen afterwards. */}
          {!account() && <button className="btn lp-signin" onClick={() => { if (signIn("/#/")) onSignedIn(); }}>Sign in</button>}
        </div>
        <h1 className="lp-head">Make funny cartoons with your own voice.</h1>
        <p className="lp-small">Pick who's talking, hit the red button, say something.</p>
        <div className="lp-demo">
          {id ? <TimelineLoader id={id} editor={EmbeddedQuick} onBack={() => {}} onError={m => setProblem(m)} />
            : <div className="lp-wait">{problem ?? "Getting it ready…"}</div>}
        </div>
        {id && problem && <p className="lp-problem">{problem}</p>}
        <button className="btn big yellow wide lp-own-big" onClick={onOwn}>Make your own — it's free</button>

        <ol className="lp-points">
          <li>
            <b>Cartoon channels with rough drawings and their makers' own voices are getting millions of views.</b>
            <div className="lp-examples" aria-label="Example channels (placeholders)">
              {EXAMPLES.map(c => (
                <div key={c.name} className="lp-card">
                  <span className="lp-tag">Example</span>
                  <b>{c.name}</b>
                  <span>{c.followers}</span>
                  <span>{c.views}</span>
                </div>
              ))}
            </div>
          </li>
          <li><b>You're funny but can't draw?</b> Sketchy makes those videos in minutes.</li>
          <li><b>Earn money from your humour.</b> Get paid when people you invite subscribe.</li>
        </ol>

        <button className="link-btn lp-start" onClick={onStart}>Get started</button>
      </Body>
    </Page>
  );
}
